const s = {
  basicPrice: {
    font: {
      type: "heading",
      size: {
        l: "3",
        m: "2",
        s: "1",
        xs: "m1",
        xxs: "m2"
      }
    }
  },
  savePrice: {
    font: {
      type: "paragraph",
      size: {
        l: "2",
        m: "1",
        s: "m1",
        xs: "m2",
        xxs: "m3"
      }
    }
  },
  prevPrice: {
    font: {
      type: "paragraph",
      size: {
        l: "1",
        m: "m1",
        s: "m1",
        xs: "m2",
        xxs: "m3"
      }
    }
  }
}, a = {
  styledSalePriceWrapperConfig: {
    marginBottom: {
      l: "var(--spacing-global-space1)",
      m: "var(--spacing-global-space2)",
      s: "var(--spacing-global-space2)",
      xs: "0px",
      xxs: "0px"
    }
  }
};
export {
  s as priceConfig,
  a as styledPriceConfig
};
